<footer class="footer container mat-typography">
  <mat-divider></mat-divider>
  <div class="footer-links">
    <span class="text-small">©{{ today |date: 'yyyy' }} Hageda-Stumpf Pharmahandel GmbH</span>
    <span class="sep"></span>
    <a mat-button color="neutral" [routerLink]="open ? '/open/page/impressum' : '/page/impressum'">Impressum</a>
    <span class="sep">|</span>
    <a mat-button color="neutral" [routerLink]="open ? '/kontakt' : '/kontaktformular'">Kontakt</a>
    <span class="sep">|</span>
    <a mat-button color="neutral" href="https://dehappsacc.blob.core.windows.net/documents/AGB_Hageda.pdf" target="_blank">AGB</a>
    <span class="sep">|</span>
    <a mat-button color="neutral" href="https://dehappsacc.blob.core.windows.net/documents/ARB_HAGEDA.pdf" target="_blank">Retourenbedingungen</a>
    <span class="sep">|</span>
    <a mat-button color="neutral" [routerLink]="open ? '/open/page/datenschutz' : '/page/datenschutz'">
      Datenschutz
    </a>
    <span class="sep">|</span>
    <a mat-button color="neutral" [routerLink]="open ? '/open/page/nutzungsbedingungen' : '/page/nutzungsbedingungen'">
      Nutzungbedingungen
    </a>
    <span class="sep">|</span>
    <a mat-button color="neutral" [routerLink]="open ? '/open/page/hgf' : '/page/hgf'">
      Häufig gestellte Fragen
    </a>
  </div>
</footer>
